// base
import React, { Component } from "react";

// components
import {
  Layout,
  PageState,
  Search,
  Pager,
  ContentsBox,
  IsLoadingLayout,
  TopBalanceComponent,
} from "../../components";
import ReactTooltip from "react-tooltip";
import { toFixed } from "../../../helper";

// assets
import "./topRank.scss";
import { topRank, totalBalance } from "../../../api";
import { connect } from "react-redux";

class Ranking extends Component {
  constructor(props) {
    super(props);
    this.state = this.initState();
  }

  initState = () => {
    return {
      pageNum: 1,
      pages: 1,
      pageSize: 25,
      topRanks: null,
      totalBalance: 0,
      totalAccounts: 0,
    };
  };

  getTopRanks = (pageNum) => {
    topRank(pageNum, this.state.pageSize).then((res) => {
      if (res.data) {
        this.setState({
          topRanks: res.data.list,
          pages: res.data.pages,
          pageNum: res.data.pageNum,
        });
      }
    });
  };

  getTotalBalance = () => {
    totalBalance().then((res) => {
      if (res.data) {
        this.setState({
          totalBalance: toFixed(res.data.TotalBalance),
          totalAccounts: res.data.Accounts,
        });
      }
    });
  };

  movePage = (action) => {
    const { pageNum, pages } = this.state;

    if (action === "next" && pageNum < pages) {
      this.setState({ topRanks: null });
      this.getTopRanks(pageNum + 1);
    } else if (action === "prv" && pageNum > 1) {
      this.setState({ topRanks: null });
      this.getTopRanks(pageNum - 1);
    } else if (action === "first") {
      this.setState({ topRanks: null });
      this.getTopRanks(1);
    } else if (action === "last") {
      this.setState({ topRanks: null });
      this.getTopRanks(pages);
    }
  };

  componentDidMount() {
    this.getTopRanks(1);
    this.getTotalBalance();
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  render() {
    const { pageNum, pages, topRanks } = this.state;

    return (
      <Layout>
        <main className="blocks_main">
          <div className="l-wrapper">
            <div className="page_upper">
              <Search />
              <PageState pageName="Balance Ranking" />
            </div>
            <div className="blocks_contents_group">
              <div className="col blocks">
                <ContentsBox title="Balance Ranking">
                  {topRanks ? (
                    <>
                      <TopBalanceComponent
                        accountList={this.state.topRanks}
                        totalBalance={this.state.totalBalance}
                        totalAccounts={this.state.totalAccounts}
                        pageNum={this.state.pageNum}
                        pageSize={this.state.pageSize}
                      />
                      <div className="blocks_pager">
                        <Pager
                          currentPage={pageNum}
                          totalnum={pages}
                          isFull={true}
                          movepage={this.movePage}
                        />
                      </div>
                    </>
                  ) : (
                    <IsLoadingLayout isLoading={true} />
                  )}
                </ContentsBox>
              </div>
              <ReactTooltip />
            </div>
          </div>
        </main>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    network: state.appState.network,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Ranking);
